window.OKJS = window.OKJS || {};
(function (OKJS) {
    OKJS.Quicklinks = {

        settings: {

        },

        init: function () {
            var s = this.settings;
            this.setupQuicklinks();
        },

        setupQuicklinks: function () {
            var quicklinkCategories = document.querySelectorAll('.js-quicklink-category > input');

            for (var i = 0; i < quicklinkCategories.length; i++) {
                var categoryCheckbox = quicklinkCategories[i];
                categoryCheckbox.addEventListener('change', function () {
                    var date = new Date();
                    date.setFullYear(date.getFullYear() + 1);

                    var json = OKJS.Global.parseJson(OKJS.Global.readCookieString(this.dataset.cookie)) || [];
                    if (!(json instanceof Array)) {
                        json = []; //bad data, enforce array datastructure
                    }
                    var categoryId = this.dataset.categoryid;
                    var pageId = this.dataset.pageid;
                    var data = [pageId, categoryId];
                    var shouldAdd = !this.checked;

                    //first remove all existing instances of this data
                    var existing = json.filter(function (c) {
                        return c && c.length > 1 && c[0] == pageId && c[1] == categoryId;
                    });
                    if (existing.length) {
                        json = json.filter(function (c) {
                            return existing.indexOf(c) == -1;
                        });
                    }

                    if (shouldAdd) {
                        //make room if the array is full (max 20), done from the front so we remove the oldest
                        if (json.length > 19) {
                            json.shift();
                        }

                        json.push(data);
                    }

                    document.cookie = this.dataset.cookie + '=' + JSON.stringify(json) + ';path=/;expires=' + date.toUTCString();
                });
            }
        }
    };

}(window.OKJS));
